/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_TitleInputs */

const en_two_fa_recovery_title = /** @type {(inputs: Two_Fa_Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save your recovery codes`)
};

const nl_two_fa_recovery_title = /** @type {(inputs: Two_Fa_Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewaar je herstelcodes`)
};

/**
* | output |
* | --- |
* | "Save your recovery codes" |
*
* @param {Two_Fa_Recovery_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_title = /** @type {((inputs?: Two_Fa_Recovery_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_title(inputs)
	return en_two_fa_recovery_title(inputs)
});